import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import { Modal } from 'react-bootstrap-5';

import LoadingSpinner from 'components/ui/loading_spinner';

export default class MergeRecordsModal extends React.Component {
  static propTypes = {
    recordType: PropTypes.string,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  state = { showInProgressSpinner: false };

  handleRecordsMerge = () => {
    this.setState(
      { showInProgressSpinner: true },
      () => {
        this.props.onSubmit().then(() => {
          this.setState({ showInProgressSpinner: false });
        });
      }
    );
  }

  recordType() {
    return this.props.recordType || 'Records';
  }

  renderModalButtons() {
    if (this.state.showInProgressSpinner) {
      return (<LoadingSpinner skipTopBuffer={true} />);
    } else {
      return (
        <>
          <Button label="Cancel" variant="ghost" onClick={this.props.onCancel} />
          <Button onClick={this.handleRecordsMerge}>
            Merge { this.recordType() }
          </Button>
        </>
      );
    }
  }

  render() {
    return (
      <Modal centered show={this.props.shown} onHide={this.props.onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Merge { this.recordType() }</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-2">
          <div> You are about to merge two { this.recordType().toLowerCase() }. </div>
          <div> This action is permanent and cannot be undone. Are you sure you want to merge? </div>
        </Modal.Body>
        <Modal.Footer>
          { this.renderModalButtons() }
        </Modal.Footer>
      </Modal>
    );
  }
}
